import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "logs-table" }
const _hoisted_2 = {
  key: 0,
  class: "table-container"
}
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-striped table-hover" }
const _hoisted_5 = { class: "table-dark" }
const _hoisted_6 = { class: "alert alert-danger" }
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "table-controls mb-3" }
const _hoisted_9 = { class: "row align-items-center" }
const _hoisted_10 = { class: "col-lg-3 col-md-6" }
const _hoisted_11 = { class: "d-flex align-items-center gap-2" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-lg-3 col-md-6" }
const _hoisted_14 = { class: "d-flex align-items-center gap-2" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-lg-3 col-md-6" }
const _hoisted_17 = { class: "d-flex align-items-center gap-2" }
const _hoisted_18 = { class: "dropdown" }
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = ["id", "checked", "onChange"]
const _hoisted_22 = ["for"]
const _hoisted_23 = { class: "col-lg-3 col-md-6 text-md-end" }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = {
  class: "table-responsive",
  style: {"overflow-x":"auto"}
}
const _hoisted_26 = { class: "table table-striped table-hover logs-table-expanded" }
const _hoisted_27 = { class: "table-dark" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_30 = {
  key: 0,
  class: "sort-indicator"
}
const _hoisted_31 = {
  key: 0,
  class: "fas fa-sort-up"
}
const _hoisted_32 = {
  key: 1,
  class: "fas fa-sort-down"
}
const _hoisted_33 = {
  key: 2,
  class: "fas fa-sort text-muted"
}
const _hoisted_34 = {
  key: 0,
  class: "group-header-row"
}
const _hoisted_35 = ["colspan"]
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "badge bg-secondary ms-2" }
const _hoisted_39 = {
  key: 2,
  class: "expanded-row"
}
const _hoisted_40 = ["colspan"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["colspan"]
const _hoisted_43 = {
  key: 0,
  "aria-label": "Pagination"
}
const _hoisted_44 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "d-flex align-items-center gap-2" }
const _hoisted_48 = ["value", "max"]
const _hoisted_49 = { class: "text-muted" }

import { watch } from "vue";
import { FlexRender } from "@tanstack/vue-table";
import { useLogsTable } from "../composables/useLogsTable.js";
import LogDetailsExpanded from "./LogDetailsExpanded.vue";
import { getActionLabel, getLogSubjectLabel } from "../../../../composables/useLogDisplay.js";


export default {
  __name: 'LogsTable',
  props: {
	logs: {
		type: Array,
		default: () => [],
	},
	loading: {
		type: Boolean,
		default: false,
	},
	error: {
		type: String,
		default: "",
	},
	maxCount: {
		type: Number,
		default: null,
	},
},
  emits: ["column-filters-change"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const { table, columnFilters } = useLogsTable(() => props.logs);

// Expose table instance to parent
__expose({ table });

// Emit column filter changes to parent
const emit = __emit;

// One placeholder width per visible table column, so the skeleton matches the table
const SKELETON_COLUMN_WIDTHS = ["40px", "80px", "120px", "100px", "150px", "80px", "200px", "120px", "180px"];

// Handle grouping changes
const handleGroupingChange = (event) => {
	const columnId = event.target.value;
	if (columnId) {
		table.setGrouping([columnId]);
	} else {
		table.setGrouping([]);
	}
};

// Generate group header labels
const getGroupHeaderLabel = (row) => {
	const groupingValue = row.getGroupingValue(row.groupingColumnId);
	const columnId = row.groupingColumnId;
	
	if (columnId === 'subject') {
		const sampleLog = row.subRows?.[0]?.original;
		return sampleLog ? getLogSubjectLabel(sampleLog) : 'Unbekannt';
	}

	if (columnId === 'action') {
		return getActionLabel(groupingValue);
	}
	
	if (columnId === 'user') {
		return groupingValue?.displayName || groupingValue?.username || 'Unbekannter Benutzer';
	}
	
	if (columnId === 'room') {
		return groupingValue || 'Unbekannter Raum';
	}
	
	if (columnId === 'bookingType') {
		return groupingValue?.title || 'Unbekannter Typ';
	}
	
	return groupingValue || 'Ungruppiert';
};

// Watch for column filter changes and emit to parent
watch(
	columnFilters,
	(newFilters) => {
		emit("column-filters-change", newFilters);
	},
	{ deep: true }
);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Loading State "),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createCommentVNode(" Table Controls Skeleton "),
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"table-controls mb-3\"><div class=\"row align-items-center\"><div class=\"col-md-6\"><div class=\"d-flex align-items-center gap-2\"><div class=\"skeleton skeleton-label\"></div><div class=\"skeleton skeleton-select\"></div></div></div><div class=\"col-md-6 text-md-end\"><div class=\"skeleton skeleton-info\"></div></div></div></div>", 1)),
          _createCommentVNode(" Table Skeleton "),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("thead", _hoisted_5, [
                _createElementVNode("tr", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SKELETON_COLUMN_WIDTHS, (_, index) => {
                    return _createElementVNode("th", { key: index }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("div", { class: "skeleton skeleton-header" }, null, -1 /* CACHED */)
                    ]))])
                  }), 64 /* STABLE_FRAGMENT */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createElementVNode("tr", { key: n }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SKELETON_COLUMN_WIDTHS, (width, index) => {
                      return _createElementVNode("td", { key: index }, [
                        _createElementVNode("div", {
                          class: "skeleton skeleton-cell",
                          style: _normalizeStyle({ width })
                        }, null, 4 /* STYLE */)
                      ])
                    }), 64 /* STABLE_FRAGMENT */))
                  ])
                }), 64 /* STABLE_FRAGMENT */))
              ])
            ])
          ])
        ]))
      : (__props.error)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" Error State "),
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
              _createTextVNode(" " + _toDisplayString(__props.error), 1 /* TEXT */)
            ])
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        : (!__props.logs || __props.logs.length === 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" Empty State "),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-center py-5" }, [
                _createElementVNode("i", {
                  class: "fas fa-search text-muted",
                  style: {"font-size":"3rem"}
                }),
                _createElementVNode("h4", { class: "mt-3 text-muted" }, " Keine Einträge gefunden "),
                _createElementVNode("p", { class: "text-muted" }, " Passen Sie die Filter an oder erweitern Sie den Zeitraum. ")
              ], -1 /* CACHED */))
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createCommentVNode(" Table "),
              _createElementVNode("div", _hoisted_7, [
                _createCommentVNode(" Table Controls "),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label mb-0" }, "Einträge pro Seite:", -1 /* CACHED */)),
                        _createElementVNode("select", {
                          value: _unref(table).getState().pagination.pageSize,
                          class: "form-select form-select-sm",
                          style: {"width":"auto"},
                          onChange: _cache[0] || (_cache[0] = (e) => _unref(table).setPageSize(Number(e.target.value)))
                        }, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("option", { value: "10" }, " 10 ", -1 /* CACHED */),
                          _createElementVNode("option", { value: "25" }, " 25 ", -1 /* CACHED */),
                          _createElementVNode("option", { value: "50" }, " 50 ", -1 /* CACHED */),
                          _createElementVNode("option", { value: "100" }, " 100 ", -1 /* CACHED */)
                        ]))], 40 /* PROPS, NEED_HYDRATION */, _hoisted_12)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label mb-0" }, "Gruppierung:", -1 /* CACHED */)),
                        _createElementVNode("select", {
                          value: _unref(table).getState().grouping[0] || '',
                          class: "form-select form-select-sm",
                          onChange: handleGroupingChange
                        }, [...(_cache[10] || (_cache[10] = [
                          _createStaticVNode("<option value=\"\"> Keine </option><option value=\"subject\"> Nach Buchung/Serie </option><option value=\"action\"> Nach Aktion </option><option value=\"user\"> Nach Benutzer </option><option value=\"room\"> Nach Raum </option><option value=\"bookingType\"> Nach Typ </option><option value=\"bookingKind\"> Nach Buchungstyp </option>", 7)
                        ]))], 40 /* PROPS, NEED_HYDRATION */, _hoisted_15)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label mb-0" }, "Spalten:", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_18, [
                          _cache[12] || (_cache[12] = _createElementVNode("button", {
                            class: "btn btn-outline-secondary btn-sm dropdown-toggle",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "data-bs-popper-config": "{\"strategy\":\"fixed\"}",
                            "aria-expanded": "false"
                          }, " Anzeigen ", -1 /* CACHED */)),
                          _createElementVNode("ul", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(table).getAllLeafColumns().filter(col => col.getCanHide()), (column) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: column.id,
                                class: "dropdown-item-text"
                              }, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("input", {
                                    id: `column-${column.id}`,
                                    class: "form-check-input",
                                    type: "checkbox",
                                    checked: column.getIsVisible(),
                                    onChange: $event => (column.toggleVisibility())
                                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_21),
                                  _createElementVNode("label", {
                                    for: `column-${column.id}`,
                                    class: "form-check-label"
                                  }, _toDisplayString(typeof column.columnDef.header === 'function'
                            ? column.columnDef.header()
                            : column.columnDef.header), 9 /* TEXT, PROPS */, _hoisted_22)
                                ])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("small", _hoisted_24, " Zeige " + _toDisplayString(_unref(table).getState().pagination.pageIndex *
                  _unref(table).getState().pagination.pageSize +
                  1) + " bis " + _toDisplayString(Math.min(
                  (_unref(table).getState().pagination.pageIndex + 1) *
                    _unref(table).getState().pagination.pageSize,
                  _unref(table).getFilteredRowModel().rows.length
                )) + " von " + _toDisplayString(_unref(table).getFilteredRowModel().rows.length) + " Einträgen ", 1 /* TEXT */)
                    ])
                  ])
                ]),
                _createCommentVNode(" Responsive Table Wrapper with horizontal scroll "),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("table", _hoisted_26, [
                    _createElementVNode("thead", _hoisted_27, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(table).getFlatHeaders(), (header) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: header.id,
                            class: _normalizeClass({
                  sortable: header.column.getCanSort(),
                  'expand-column': header.id === 'expand',
                }),
                            onClick: $event => (header.column.getToggleSortingHandler()?.($event))
                          }, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_unref(FlexRender), {
                                render: header.column.columnDef.header,
                                props: header.getContext()
                              }, null, 8 /* PROPS */, ["render", "props"]),
                              (header.column.getCanSort())
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                    (header.column.getIsSorted() === 'asc')
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_31))
                                      : (header.column.getIsSorted() === 'desc')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_32))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_33))
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ])
                          ], 10 /* CLASS, PROPS */, _hoisted_28))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(table).getRowModel().rows, (row) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: row.id
                        }, [
                          _createCommentVNode(" Group header row "),
                          (row.getIsGrouped())
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                                _createElementVNode("td", {
                                  colspan: _unref(table).getVisibleLeafColumns().length,
                                  class: "group-header"
                                }, [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-outline-primary border-0 me-2",
                                      onClick: $event => (row.toggleExpanded())
                                    }, [
                                      _createElementVNode("i", {
                                        class: _normalizeClass({
                          'fas fa-chevron-down': row.getIsExpanded(),
                          'fas fa-chevron-right': !row.getIsExpanded()
                        })
                                      }, null, 2 /* CLASS */)
                                    ], 8 /* PROPS */, _hoisted_37),
                                    _createElementVNode("strong", null, _toDisplayString(getGroupHeaderLabel(row)), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_38, _toDisplayString(row.subRows?.length || 0), 1 /* TEXT */)
                                  ])
                                ], 8 /* PROPS */, _hoisted_35)
                              ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" Regular data row "),
                                _createElementVNode("tr", {
                                  class: _normalizeClass(["main-row", { 
                  expanded: row.getIsExpanded(),
                  'grouped-row': row.depth > 0
                }])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.getVisibleCells(), (cell) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: cell.id,
                                      class: _normalizeClass({ 'expand-column': cell.column.id === 'expand' })
                                    }, [
                                      _createVNode(_unref(FlexRender), {
                                        render: cell.column.columnDef.cell,
                                        props: cell.getContext()
                                      }, null, 8 /* PROPS */, ["render", "props"])
                                    ], 2 /* CLASS */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 2 /* CLASS */)
                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                          _createCommentVNode(" Expanded row "),
                          (row.getIsExpanded() && !row.getIsGrouped())
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                                _createElementVNode("td", {
                                  colspan: row.getAllCells().length,
                                  class: "p-0"
                                }, [
                                  _createVNode(LogDetailsExpanded, {
                                    log: row.original
                                  }, null, 8 /* PROPS */, ["log"])
                                ], 8 /* PROPS */, _hoisted_40)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    (__props.maxCount && __props.logs.length === __props.maxCount)
                      ? (_openBlock(), _createElementBlock("tfoot", _hoisted_41, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", {
                              colspan: _unref(table).getVisibleLeafColumns().length,
                              class: "text-muted text-center small"
                            }, [
                              _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1 /* CACHED */)),
                              _createTextVNode(" Es werden nur die neuesten " + _toDisplayString(__props.maxCount) + " Einträge angezeigt. ", 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_42)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createCommentVNode(" Pagination "),
                (_unref(table).getPageCount() > 1)
                  ? (_openBlock(), _createElementBlock("nav", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            class: "btn btn-outline-primary me-2",
                            disabled: !_unref(table).getCanPreviousPage(),
                            onClick: _cache[1] || (_cache[1] = $event => (_unref(table).previousPage()))
                          }, [...(_cache[15] || (_cache[15] = [
                            _createElementVNode("i", { class: "fas fa-chevron-left me-1" }, null, -1 /* CACHED */),
                            _createTextVNode(" Zurück ", -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_45),
                          _createElementVNode("button", {
                            class: "btn btn-outline-primary",
                            disabled: !_unref(table).getCanNextPage(),
                            onClick: _cache[2] || (_cache[2] = $event => (_unref(table).nextPage()))
                          }, [...(_cache[16] || (_cache[16] = [
                            _createTextVNode(" Weiter ", -1 /* CACHED */),
                            _createElementVNode("i", { class: "fas fa-chevron-right ms-1" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_46)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-muted" }, "Seite", -1 /* CACHED */)),
                          _createElementVNode("input", {
                            value: _unref(table).getState().pagination.pageIndex + 1,
                            type: "number",
                            min: "1",
                            max: _unref(table).getPageCount(),
                            class: "form-control form-control-sm",
                            style: {"width":"80px"},
                            onChange: _cache[3] || (_cache[3] = (e) => _unref(table).setPageIndex(Number(e.target.value) - 1))
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_48),
                          _createElementVNode("span", _hoisted_49, "von " + _toDisplayString(_unref(table).getPageCount()), 1 /* TEXT */)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ]))
}
}

}